import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';
import { getUser } from '../../utils/Common';

function RetailerSearch({ setRetailer, value, searchParam, label = 'lblRetailer', shipTo = 0 }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const { t } = useTranslation('overview');
  const [loadingText, setLoadingText] = React.useState(t('lblSearchText'));
  const loading = open && options.length === 0;

  const SessionUser = getUser();

  React.useEffect(() => {
    let active = true;
    if (!open) return;

    axios
      .get(
        `/GetRetailer/${(search || ' ')
          .toString()
          .toLocaleLowerCase(localStorage.i18nextLng_normalized)}/${shipTo}`
      )
      .then(res => {
        if (!active) return;
        if (res.data) {
          setOptions(res.data);
          setLoadingText(t('lblSearchText'));
        } else {
          setLoadingText(t('lblText'));
          setOptions([]);
        }
      })
      .catch(() => setOptions([]));

    return () => {
      active = false;
    };
  }, [open, search, shipTo, t]);

  React.useEffect(() => {
    if (searchParam?.length > 0) setSearch(searchParam);
  }, [searchParam]);

  const clearRetailer = () => setRetailer({ Dsc: '', Id: 0 });

  return (
    <Autocomplete
      id="retailer-autocomplete"
      open={open}
      size="small"
      value={value?.Id ? value : null}
      freeSolo
      options={options}
      filterOptions={opts => opts} // server-side filtering
      loading={loading}
      loadingText={loadingText}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      getOptionLabel={option =>
        typeof option === 'string' ? option : option?.Dsc ? `${option.Dsc}` : ''
      }
      getOptionSelected={(opt, val) => opt?.Id === val?.Id}
      onChange={(_, newValue, reason) => {
        // Seçim yoksa veya temizlendiyse backend'e 0 gönderilecek
        if (reason === 'clear' || !newValue || typeof newValue === 'string') {
          clearRetailer();
          return;
        }
        // Seçim varsa ID gönder
        setRetailer({ Dsc: newValue.Dsc, Id: newValue.Id });
      }}
      onInputChange={(_, v, reason) => {
        setSearch(v);
        // Yazı değişiyorsa seçim geçersiz; ID=0
        if (reason === 'input') clearRetailer();
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          label={t(label)}
          size="small"
          required={SessionUser.TenantId === 79}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={18} />}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
}

export default RetailerSearch;
